/**
 * Extracted from sections/fa-social-proof-reviews.liquid (inline <script> at line 191).
 * Config bridge: window.__nsSocialProofReviewsSections, keyed by section id. The inline block
 * only needed Liquid for the section id, so the id is handed over as data
 * and the logic now runs from a cacheable, deferred asset instead of being
 * parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances each initialise.
 */

(function () {
  var cfg = window.__nsSocialProofReviewsSections = window.__nsSocialProofReviewsSections || {};
  function boot(nsSectionId, nsSettings) {
        (function () {
          var swiperInstance = null;

          function initSprSwiper() {
            var root = document.getElementById(`shopify-section-${nsSectionId}`);
            if (!root) return;

            var swiperEl = root.querySelector('.fa-spr__swiper');
            if (!swiperEl) return;
            if (typeof Swiper === 'undefined') return;

            if (swiperInstance) {
              swiperInstance.destroy(true, true);
              swiperInstance = null;
            }

            var paginationEl = root.querySelector('.fa-spr__pagination');
            var prevEl = root.querySelector('.fa-spr__prev');
            var nextEl = root.querySelector('.fa-spr__next');

            swiperInstance = new Swiper(swiperEl, {
              slidesPerView: 1,
              spaceBetween: 16,
              speed: 500,
              grabCursor: true,
              loop: false,
              navigation: prevEl && nextEl ? { nextEl: nextEl, prevEl: prevEl } : false,
              pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
              breakpoints: {
                700: { slidesPerView: 2, spaceBetween: 16 },
                1000: { slidesPerView: 3, spaceBetween: 16 }
              },
              on: {
                init: function () {
                  if (this.pagination && this.pagination.render) {
                    this.pagination.render();
                    this.pagination.init();
                    this.pagination.update();
                  }
                }
              }
            });
          }

          function waitForSwiper(cb) {
            if (typeof Swiper !== 'undefined') { cb(); return; }
            var check = setInterval(function () {
              if (typeof Swiper !== 'undefined') { clearInterval(check); cb(); }
            }, 50);
          }

          waitForSwiper(initSprSwiper);

          if (typeof Shopify !== 'undefined' && Shopify.designMode) {
            document.addEventListener('shopify:section:load', function (e) {
              if (e.detail.sectionId === `${nsSectionId}`) initSprSwiper();
            });
          }
        })();
    
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
